import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { SharedDataService } from 'src/app/shared/services/shared-data.service';

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit , OnDestroy {
  public userName: string;
  public profileImg: "assets/images/dashboard/profile.jpg";
  userDetails : any;

  userSubscription : Subscription;

  constructor(public router: Router , private sharedData : SharedDataService) {
    if (JSON.parse(localStorage.getItem("user"))) {
    } else {
      // this.logoutFunc();
    }
  }



  ngOnDestroy(): void {
      if(this.userSubscription) this.userSubscription.unsubscribe();
  }

  getUserDetails(){
   this.userSubscription = this.sharedData.userDetails.subscribe(resdata =>{
      this.userDetails = resdata ;
    })
  }
  ngOnInit() {
    this.getUserDetails();

  }

  logoutFunc() {
    localStorage.clear();

    this.router.navigateByUrl('/');
  }
}
